module.exports = {
  templateUrl: 'profile/components/tabs/personal-informations/personal-informations.html',
  controller: class PersonalInformations {

    static $inject =[
      '$filter',
      '$ngRedux',
      '$scope',
      '$timeout',
      '$translate',
      'PatientAppContextService',
      'PatientsService',
      'ProductService',
    ];

    editing = {
      informations: false,
      address: false,
      contacts: false,
      medicalInfos: false,
    };

    kinds =['home', 'mobile', 'work', 'other'];

    territories = [];

    constructor(
      $filter,
      $ngRedux,
      $scope,
      $timeout,
      $translate,
      PatientAppContextService,
      PatientsService,
      ProductService,
    ) {
      this.$filter = $filter;
      this.$ngRedux = $ngRedux;
      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$translate = $translate;
      this.PatientAppContextService = PatientAppContextService;
      this.PatientsService = PatientsService;
      this.ProductService = ProductService;

      this.model = this.PatientAppContextService.context.authenticatedPatient;
      this.model.profile.province = this.formatTerritory(this.model.profile.province);
      this.model.age = `${moment().diff(this.model.birthDate, 'years')} ${$translate.instant('update.informations.list_items.years_old')}`;
      this.months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
      this.years = [moment().year()];
      const iterable = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
      for (let j = 0; j < iterable.length; j++) {
        this.years.push(moment().year() + iterable[j]);
      }

      this.fetchTerritories();
    }

    $onInit() {
      this.group = this.$ngRedux.getState().group;
      this.kinds = ['home', 'mobile', 'work'];

      if (this.group.emrProviderMnemonic !== 'telus') {
        this.kinds.push('other');
      }

      this.canUpdate = this.group.emrProviderMnemonic !== 'softinfo' && !(this.group.emrProviderMnemonic === 'telus' && this.group.emrProviderSubtype === 'MA');

      // Wait on next frame for elements to be set correctly
      this.$timeout(() => {
        this.autoHeightElements = angular.element('.-auto-height');

        this.autoHeightElements.on('input change', this.onTextareaChange);

        this.$scope.$on('$destroy', () => {
          this.autoHeightElements.off('input change', this.onTextareaChange); // remove the handler added earlier
        });

        this.textareaAutoHeight();
      });
    }

    hasManitobaProduct() {
      return this.ProductService.isAvailable('MANITOBA_BOOKING');
    }

    hasGenericHinProduct() {
      return this.ProductService.isAvailable('GENERIC_PHN');
    }

    toggleEditing = (section, toggle) => {
      this.editing[section] = toggle;
      if (toggle) {
        this.backupModel = angular.copy(this.model);
      }

      if (!toggle) {
        this.model = this.backupModel;
      }
    };

    submit(section) {
      this.model.groupId = this.PatientAppContextService.context.group.id;
      this.submittingInformations = true;

      if (section === 'address') {
        this.PatientsService.updateAddress(this.model).then(this.updated, this.failedUpdate);
      }

      if (section === 'contacts') {
        const contactMethods = [];
        _.forEach(this.model.profile.contactMethods, (contactMethod) => {
          if (contactMethod !== null && contactMethod.kind !== null && contactMethod.number !== null && contactMethod.number.length > 0) {
            contactMethods.push({
              kind: {
                mnemonic: contactMethod.kind,
              },
              number: contactMethod.number,
            });
          }
        });

        this.PatientsService
          .updateContactMethods(this.model.id, this.model.groupId, contactMethods).then(() => {
            this.PatientsService
              .loadPatient(this.model.id)
              .then(() => {
                this.updated();
              });
          }, this.failedUpdate);
      }

      if (section === 'medicalInfos') {
        this.PatientsService.updateMedicalInfos(this.model).then(this.updated, this.failedUpdate);
      }

      this.editing[section] = false;
    }

    addContactMethod() {
      this.model.profile.contactMethods.push({
        kind: this.getKinds()[0],
      });
    }

    removeContactMethod(event, offset) {
      event.preventDefault();
      _.pullAt(this.model.profile.contactMethods, offset);
    }

    updated = () => {
      this.submittingInformations = false;
      this.model.profile.lastUpdatedAt = moment().toISOString();
      this.model.profile.lastUpdatedBy = _.assign({}, {
        kind: 'patient',
      }, _.pick(this.PatientAppContextService.context.authenticatedPatient, ['id', 'firstName', 'middleName', 'lastName', 'kind']));

      this.backupModel = angular.copy(this.model);
    };

    failedUpdate = () => {
      this.submittingInformations = false;
      this.model = this.backupModel;
    };

    fetchTerritories() {
      this.PatientsService.territories().then(this.territoriesFetched);
    }

    territoriesFetched = (response) => {
      this.territories = response.data.territories;
    };

    getLastUpdatedMessage() {
      if (this.model.profile.lastUpdatedAt) {
        const lastUpdatedDate = this.$filter('datetime')(this.model.profile.lastUpdatedAt, 'day_month_year_and_time');
        const lastUpdatedBy = this.model.profile.lastUpdatedBy;

        if (lastUpdatedBy && lastUpdatedBy.kind === 'patient') {
          if (lastUpdatedBy.id === this.PatientAppContextService.context.authenticatedPatient.id) {
            return this.$translate.instant('update.profile.last_updated.yourself', {
              date: lastUpdatedDate,
            });
          }
          return this.$translate.instant('update.profile.last_updated.other_patient', {
            date: lastUpdatedDate,
            patientName: this.$filter('patientName')(lastUpdatedBy),
          });
        }
        return this.$translate.instant('update.profile.last_updated.clinic', {
          date: lastUpdatedDate,
        });
      }
      return '';
    }

    knownDiseasesAllergiesAvailable() {
      return this.ProductService.isAvailable('PATIENT_KNOWN_ALLERGIES_AND_DISEASES', { id: this.model.groupId });
    }

    getKinds(contactMethod) {
      if (this.group.emrProviderMnemonic === 'telus') {
        return this.kinds.filter(kind => (contactMethod && kind === contactMethod.kind) || (kind !== 'other' && this.model.profile.contactMethods.map(cm => cm.kind).indexOf(kind) === -1));
      }

      return this.kinds;
    }

    onTextareaChange = () => {
      this.$timeout(this.textareaAutoHeight);
    };

    textareaAutoHeight = () => {
      _.each(this.autoHeightElements, (element) => {
        // Reset height to 6em before setting new height else it doesn't work
        element.style.height = '6em';
        element.style.height = `${element.scrollHeight}px`;
      });
    };

    formatTerritory = location => location.replace('ca-', '').toUpperCase()

    get firstContactMethod() {
      return this.model.profile.contactMethods[0];
    }

    get hinMessageSuffix() {
      if (this.hasManitobaProduct()) {
        return 'phin';
      } else if (this.hasGenericHinProduct()) {
        return 'generic_hin';
      }
      return 'hin';
    }
  },
};



// WEBPACK FOOTER //
// ./profile/components/tabs/personal-informations/personal-informations.js